import { connectorsForWallets, getDefaultConfig } from '@rainbow-me/rainbowkit'
import { mainnet, sepolia } from 'wagmi/chains'
import {
  metaMaskWallet,
  coinbaseWallet,
  rainbowWallet,
  walletConnectWallet,
  rabbyWallet,
  phantomWallet,
  okxWallet,
  binanceWallet,
  injectedWallet
} from '@rainbow-me/rainbowkit/wallets'
import { http } from 'viem'

import { abi } from '../../abis/abi'
import { contractConfig } from '../staking/staking.helpers'
import brandConfig from 'brandConfig'
import { isProduction } from '../app/app.helpers'

const isEnvProd = isProduction()
const chains = isEnvProd ? [mainnet] : [sepolia]

const appConfig = {
  projectId: process.env.REACT_APP_WALLET_PROJECT_ID,
  appName: brandConfig.name,
  appDescription: brandConfig.description,
  appUrl: brandConfig.appUrl,
  appIcon: brandConfig.appIcon
}

const PUBLIC_RPCS = {
  [mainnet.id]: [
    'https://ethereum.publicnode.com',
    'https://eth.merkle.io',
    'https://rpc.ankr.com/eth',
    'https://eth.llamarpc.com',
    'https://cloudflare-eth.com'
  ],
  [sepolia.id]: [
    'https://ethereum-sepolia.publicnode.com',
    'https://rpc.sepolia.org',
    'https://sepolia.drpc.org'
  ]
}

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Popular',
      wallets: [
        injectedWallet,
        metaMaskWallet,
        coinbaseWallet,
        rainbowWallet,
        walletConnectWallet,
        rabbyWallet,
        phantomWallet,
        okxWallet,
        binanceWallet
      ]
    }
  ],
  appConfig
)

const wagmiConfig = () => {
  return getDefaultConfig({
    ...appConfig,
    connectors,
    chains,
    transports: {
      [mainnet.id]: http(PUBLIC_RPCS[mainnet.id][0]),
      [sepolia.id]: http(PUBLIC_RPCS[sepolia.id][0])
    },
    batch: {
      multicall: {
        batchSize: 1024 * 200, // Optimized for public RPCs
        wait: 16 // 16ms batching window
      }
    },
    ssr: false
  })
}

const getChain = () => {
  return isEnvProd ? mainnet : sepolia
}

const wagmiContractConfig = {
  address: contractConfig?.new,
  abi
}

const wagmiContractConfigOld = {
  address: contractConfig?.old,
  abi
}

export { wagmiConfig, getChain, wagmiContractConfig, wagmiContractConfigOld }
